import SEO from "@/components/SEO";
import { PageHero, Reveal, CTABand } from "@/components/Ui";

const sections = [
  {
    title: "Responsable du traitement",
    content: ["DMZ Normandie, entreprise individuelle représentée par Alper Donmez — SIRET 93071717800014, 7 rue Jean de la Fontaine, 27000 Évreux. Contact : dmznormandie@gmail.com ou 07 45 04 91 89."],
  },
  {
    title: "Données collectées",
    content: [
      "Via le formulaire de devis : nom, e-mail, téléphone, ville, type de projet, budget indiqué, description et photos envoyées volontairement.",
      "Via l'assistant de chat : les messages échangés et l'identifiant technique de session.",
      "Via l'espace administrateur : identifiant de connexion et cookies techniques nécessaires à la sécurité de la session.",
    ],
  },
  {
    title: "Utilisation des données",
    content: [
      "Les informations servent uniquement à répondre aux demandes, préparer les échanges et établir un devis.",
      "Une analyse automatisée peut résumer la demande et aider à son suivi ; elle ne produit aucune décision automatisée ayant un effet juridique ou significatif sur vous.",
      "Les messages du chat permettent d'améliorer les réponses et d'assurer le suivi de la conversation.",
    ],
  },
  {
    title: "Destinataires et prestataires",
    content: ["Les données sont destinées à DMZ Normandie. Des prestataires techniques peuvent intervenir pour l'envoi des e-mails, l'hébergement, la sécurité et l'analyse des demandes, uniquement dans la mesure nécessaire au fonctionnement du site."],
  },
  {
    title: "Durée de conservation",
    content: ["Les demandes de devis et échanges liés au suivi commercial sont conservés pendant une durée maximale de 24 mois, sauf obligation légale ou relation commerciale en cours. Les historiques techniques du chat sont conservés pendant une durée maximale de 12 mois."],
  },
  {
    title: "Cookies",
    content: ["Le site n'utilise pas de cookie publicitaire ou de mesure d'audience tiers. Des cookies techniques sécurisés sont utilisés uniquement pour la connexion à l'espace administrateur."],
  },
  {
    title: "Vos droits",
    content: ["Vous pouvez demander l'accès, la rectification, l'effacement, la limitation ou l'opposition au traitement de vos données en écrivant à dmznormandie@gmail.com. Vous pouvez également introduire une réclamation auprès de la CNIL si vous estimez que vos droits ne sont pas respectés."],
  },
  {
    title: "Sécurité",
    content: ["DMZ Normandie applique des mesures raisonnables de protection : accès administrateur réservé, mots de passe chiffrés, sessions sécurisées et limitation des accès aux demandes reçues."],
  },
];

export default function Confidentialite() {
  return (
    <>
      <SEO
        title="Politique de confidentialité | DMZ Normandie"
        description="Politique de confidentialité de DMZ Normandie : données collectées via le formulaire de devis, le chat, durées de conservation et droits RGPD."
        path="/confidentialite"
      />
      <PageHero title="Politique de confidentialité" subtitle="Comment DMZ Normandie collecte, utilise et protège les informations transmises depuis ce site." />
      <section className="py-20 lg:py-28" data-testid="confidentialite-page">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 space-y-10">
          {sections.map((section, i) => (
            <Reveal key={section.title} className="card-dark p-8" data-testid={`confidentialite-section-${i}`}>
              <h2 className="font-serif-display font-light text-3xl text-[#F5F5F0] mb-5">{section.title}</h2>
              <div className="space-y-3">
                {section.content.map((line) => (
                  <p key={line} className="text-sm md:text-base font-light text-zinc-400 leading-relaxed">{line}</p>
                ))}
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <CTABand />
    </>
  );
}
